export default {
    lang: {
        name: 'Ratings'
    }
}